const indexItems = [
  { name: '动作电影合集', count: '326部', icon: 'ri-shield-flash-line' },
  { name: '喜剧片单推荐', count: '258部', icon: 'ri-emotion-laugh-line' },
  { name: '悬疑推理剧场', count: '192部', icon: 'ri-search-eye-line' },
  { name: '爱情经典回顾', count: '215部', icon: 'ri-heart-pulse-line' },
  { name: '科幻视觉盛宴', count: '178部', icon: 'ri-rocket-2-line' },
  { name: '动漫番剧大全', count: '412部', icon: 'ri-ghost-smile-line' },
  { name: '纪录片专区', count: '156部', icon: 'ri-earth-line' },
  { name: '综艺娱乐汇', count: '287期', icon: 'ri-tv-2-line' },
  { name: '短片微电影', count: '503部', icon: 'ri-film-line' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            按类型分类浏览，快速定位你感兴趣的视频内容
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
            {indexItems.map((item, i) => (
              <a
                key={i}
                href={`#cards`}
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group flex items-center gap-4 bg-background-100 rounded-xl p-4 border border-background-200 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 group-hover:bg-accent-500 group-hover:text-white transition-all flex-shrink-0">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.name}
                  </h3>
                  <span className="text-xs text-foreground-500">{item.count}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}